module.exports = __webpack_public_path__ + "assets/0007de2afd01d3b98a49fc189bbbaff0.png";